export const Loading = () => (
  <div className="absolute flex justify-center items-center opacity-80	w-full h-full z-10 top-0 right-0 bg-zinc-400">
    <span className="loading loading-spinner loading-lg text-primary"></span>
  </div>
);
